import Tooltip from './Tooltip';

export * from './Tooltip.theme';

export default Tooltip;
